import './assets/css/app.min.css';
import './assets/css/bootstrap.min.css';
import './assets/css/dropzone.min.css';
import './assets/css/icons.min.css';
import './assets/css/react-tagsinput.css';
import 'react-toastify/dist/ReactToastify.min.css';
import 'react-quill/dist/quill.snow.css';
import './assets/css/bootstrap-editable.css';
import './assets/css/nestable.min.css';
import 'react-image-crop/dist/ReactCrop.css';
import 'react-datepicker/dist/react-datepicker.css';
import './assets/css/index.css';

import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n'; // Ваш файл инициализации
import { Provider } from 'react-redux';
import { createPolyfills } from './polyfills';

import { createAppStore } from './store';
import App from './App';
import { useAutoTranslation } from './helpers/useAutoTranslation';

const store = createAppStore();

const mainRender = () => {
  const state = store.getState();

  localStorage.setItem('Kak2cSavedState', JSON.stringify(state.app.appSavedState));

  ReactDOM.render(
    <I18nextProvider i18n={i18n}>
      <Provider store={store}>
        <Suspense fallback={<div>Loading...</div>}>
          <App state={state} dispatch={store.dispatch} />
        </Suspense>
      </Provider>
    </I18nextProvider>,
    document.getElementById('wrapper'),
  );
};

createPolyfills();
store.subscribe(mainRender);
mainRender();
